exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component.cta {\n  background: rgba(0, 0, 0, 0.8);\n  border-bottom: 3px solid red; }\n  .component.cta .inner {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    max-width: 128rem;\n    margin: 0 auto;\n    padding: 2.1em 1.5rem; }\n    .component.cta .inner * {\n      margin: 0; }\n    .component.cta .inner p {\n      margin-right: 2.2em;\n      font-weight: 800;\n      font-size: 2.2rem;\n      color: white;\n      text-align: right;\n      line-height: 1.2em; }\n  @media only screen and (max-width: 600px) {\n    .component.cta .inner p {\n      font-size: 1.6rem; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/blocks/cta/cta.scss
// module id = 197
// module chunks = 0